import { render, staticRenderFns } from "./MyNav.vue?vue&type=template&id=88c75366&"
import script from "./MyNav.vue?vue&type=script&lang=js&"
export * from "./MyNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports